// user_type / user_types values from GET /api/users, highest first.
export const USER_TYPE_META = {
    SUPER_ADMIN: { label: 'Super Admin', className: 'tw-bg-rose-50 tw-text-rose-600' },
    ADMIN: { label: 'Admin', className: 'tw-bg-indigo-50 tw-text-indigo-600' },
    EMPLOYEE: { label: 'Employee', className: 'tw-bg-amber-50 tw-text-amber-700' },
    OWNERSHIP: { label: 'Owner', className: 'tw-bg-emerald-50 tw-text-emerald-600' },
    OCCUPANCY: { label: 'Occupant', className: 'tw-bg-teal-50 tw-text-teal-600' },
    COMMITTEE: { label: 'Committee Member', className: 'tw-bg-violet-50 tw-text-violet-700' },
    VENDOR: { label: 'Vendor', className: 'tw-bg-sky-50 tw-text-sky-600' },
    OTHER: { label: 'Other', className: 'tw-bg-gray-100 tw-text-gray-600' },
};

// Filter dropdown — 'all' means the userType param is omitted. MEMBER is a
// filter-only value (owner or occupant); it never comes back as a user_type.
export const USER_TYPE_OPTIONS = [
    { value: 'all', label: 'All Types' },
    ...Object.entries(USER_TYPE_META).map(([value, { label }]) => ({ value, label })),
    { value: 'MEMBER', label: 'All Residents' },
];

const metaFor = (type) => USER_TYPE_META[String(type || '').toUpperCase()] || USER_TYPE_META.OTHER;

export const userTypeLabel = (type) => metaFor(type).label;

// Main type pill; `muted` renders the secondary types in user_types.
export const UserTypeBadge = ({ type, muted = false }) => (
    <span className={`tw-inline-block tw-px-2 tw-py-0.5 tw-rounded-full tw-text-[10px] tw-font-medium tw-whitespace-nowrap ${
        muted ? 'tw-bg-white tw-text-gray-500 tw-border tw-border-gray-200' : metaFor(type).className
    }`}>
        {metaFor(type).label}
    </span>
);

// Main type first, then every other type the user holds.
export const UserTypeChips = ({ type, types }) => {
    const main = type || types?.[0] || 'OTHER';
    const rest = (Array.isArray(types) ? types : []).filter((t) => t !== main);
    return (
        <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-1">
            <UserTypeBadge type={main} />
            {rest.map((t) => <UserTypeBadge key={t} type={t} muted />)}
        </div>
    );
};
